/* Les représentations d'un spectacle (page Spectacles, agenda de la saison) : une date par
   ligne, dans l'ordre chronologique (Jen, 30.10.2026). Chaque représentation :
   { date: "2027-06-12", heure: "18:00", note: "si la demande est forte" }. */

const JOURS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
const MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août",
  "septembre", "octobre", "novembre", "décembre"];

export const trierRepresentations = (reps) =>
  [...(reps || [])].sort((a, b) => `${a.date} ${a.heure}`.localeCompare(`${b.date} ${b.heure}`));

// « samedi 12 juin »
export const jourLisible = (iso) => {
  const d = new Date(`${iso}T12:00:00`);
  return `${JOURS[d.getDay()]} ${d.getDate()} ${MOIS[d.getMonth()]}`;
};

// « 18:00 » → « 18h », « 18:30 » → « 18h30 »
export const heureLisible = (h) => String(h || "").replace(/^0/, "").replace(":00", "h").replace(":", "h");

// Pour une ligne de texte (agenda) : « samedi 12 juin à 18h, dimanche 13 juin à 11h et 15h ».
export const representationsEnTexte = (reps) => {
  const jours = [];
  trierRepresentations(reps).forEach((r) => {
    const dernier = jours[jours.length - 1];
    if (dernier && dernier.date === r.date) dernier.heures.push(heureLisible(r.heure));
    else jours.push({ date: r.date, heures: [heureLisible(r.heure)] });
  });
  return jours.map((j) => `${jourLisible(j.date)} à ${j.heures.join(" et ")}`).join(", ");
};
